






import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { Carrier } from '@/modules/Carrier/interfaces/carrier'
import AppSystemInfoCard from '@/components/AppSystemInfoCard.vue'

@Component({
  components: {
    AppSystemInfoCard
  }
})
export default class CarrierDetailAdditional extends Vue {
  @Prop({ type: Object as () => Carrier }) readonly carrier!: Carrier
}
